import { ThemeProvider } from "@emotion/react";
import "./App.css";
import HomePage from "./components/HomePage/HomePage";
import { ScienceFairTheme } from "./AppTheme";

function App() {
  return (
    <ThemeProvider theme={ScienceFairTheme}>
      <div className="App">
        <HomePage />
      </div>
    </ThemeProvider>
  );
}

export default App;
